import React from "react";
import Version from "../Version/Version";

function NewVersion({
  account_slug,
  project_id,
  projectStatus,
  versions,
  versionId,
  account_id,
  setVersionCreated,
  currentUser,
  authorizationCode,
}) {
  return (
    <Version
      account_slug={account_slug}
      project_id={project_id}
      projectStatus={projectStatus}
      versions={versions}
      currentUser={currentUser}
      versionId={versionId}
      account_id={account_id}
      setVersionCreated={setVersionCreated}
      authorizationCode={authorizationCode}
    />
  );
}

export default NewVersion;
